import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';

import styles from './Update.module.less';
import {
  setOtherInfo,
  setQuietInstallPath,
  setUpdateNotifyStatus,
  setResidualNotifyStatus,
  setRarelyNotifyStatus,
} from '../../../actions/native';
import { PCStoreJsBridge } from '../../../nativeapi';
import { logging } from '../../../actions/log';
import Toast from '../../../components/Toast/Toast';
import Dialog from '../../../components/Dialog/Dialog';
import Btn from '../../../components/Btn/Btn';
import fail from '../../../static/msg-fail.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  // 当前操作的
  const [switchType, setSwitchType] = useState(null);
  // 是否升级弹窗
  const [isEnabledUpdate, setIsEnabledUpdate] = useState(false);
  // 是否右键
  const [isEnabledRight, setIsEnabledRight] = useState(false);
  // 是否残留弹窗
  const [isEnabledResidual, setIsEnabledResidual] = useState(false);
  // 是否不常用弹框
  const [isEnabledRarelyUse, setIsEnabledRarelyUse] = useState(false);

  const switchInfo = {
    1: {
      type: 1,
      isEnabled: isEnabledUpdate,
      modalInfo: '关闭升级弹窗提醒，可能会错过重要软件更新，确认是否要关闭？',
    },
    2: {
      type: 2,
      isEnabled: isEnabledRight,
      modalInfo: '建议您开启右键菜单',
    },
    3: {
      type: 3,
      isEnabled: isEnabledResidual,
      modalInfo: '建议您开启卸载残留提醒，及时清理残留，释放空间。确认是否要关闭？',
    },
    4: {
      type: 4,
      isEnabled: isEnabledRarelyUse,
      modalInfo: '建议您开启不常用软件提醒，及时管理我的软件。确认是否要关闭？',
    },
  };

  /**
   * @param {*} type
   * type: 1 升级弹框   2 右键菜单开关   3 卸载残留弹窗开关   4 不常用软件弹窗开关
   */
  const getSwitchStatus = param => {
    PCStoreJsBridge.getAppStoreSwitch({
      ...param,
    }).then(({ succ, enable }) => {
      if (succ) {
        if (param.type === 1) {
          setIsEnabledUpdate(!!enable);
          dispatch(setUpdateNotifyStatus(!!enable));
        }
        if (param.type === 2) {
          setIsEnabledRight(!!enable);
        }
        if (param.type === 3) {
          setIsEnabledResidual(!!enable);
          dispatch(setResidualNotifyStatus(!!enable));
        }
        if (param.type === 4) {
          setIsEnabledRarelyUse(!!enable);
          dispatch(setRarelyNotifyStatus(!!enable));
        }
      }
    });
  };

  useEffect(() => {
    getSwitchStatus({ type: 1 });
    // getSwitchStatus({ type: 2 });
    getSwitchStatus({ type: 3 });
    getSwitchStatus({ type: 4 });
  }, []);

  /**
   * 改变弹窗通知状态
   * type: 1：升级弹框，   2：右键菜单开关，   3：卸载残留弹窗开关，   4：不常用软件弹窗开关
   * enable true： 打开  false： 关闭
   * source: 1：设置中心勾选框创建；2：关闭商店时创建；3：创建商店时创
   */
  const setSwitchTypeStatus = (type, enable = true) => {
    PCStoreJsBridge.setAppStoreSwitch({
      type,
      enable,
      source: 1,
    }).then(
      res => {
        getSwitchStatus({ type });
        if (res.code !== 0 || !res.succ) {
          message.error({
            content: '设置失败！',
            icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
          });
        } else {
          Toast.success({ content: '设置成功！' });
        }
      },
      () => {
        message.error({
          content: '设置失败！',
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
      },
    );
  };

  const handleSwitchEnabled = useCallback(
    type => {
      if (switchInfo[type].isEnabled) {
        setSwitchType(type);
        dispatch(
          logging({
            category: 'P',
            // action: 'Tankuang_Disable_Toast',
            action: 'Tankuang_DT',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              type,
            },
          }),
        );
      } else {
        setSwitchTypeStatus(type, true);
        dispatch(
          logging({
            category: 'C',
            action: 'Tankuang_Enabled',
            label: '',
            param2: {
              source: 'Setting',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              enabled: true,
              type,
            },
          }),
        );
      }
    },
    [switchInfo, isEnabledUpdate, isEnabledRight, isEnabledRarelyUse, isEnabledResidual],
  );

  // 点击X关闭
  const hanldeCloseSwitchModal = useCallback(() => {
    setSwitchType(null);
    dispatch(
      logging({
        category: 'C',
        action: 'Tankuang_DT_Close',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: switchType,
        },
      }),
    );
  }, [switchType]);

  // 点击确定按钮
  const hanldeOkSwitchModal = useCallback(() => {
    setSwitchTypeStatus(switchType, false);
    setSwitchType(null);
    dispatch(
      logging({
        category: 'C',
        action: 'Tankuang_DT_Sure',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: switchType,
        },
      }),
    );
  }, [switchType]);

  // 点击取消关闭
  const hanldeCancelSwitchModal = useCallback(() => {
    setSwitchType(null);
    dispatch(
      logging({
        category: 'C',
        action: 'Tankuang_DT_Cancel',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: switchType,
        },
      }),
    );
  }, [switchType]);

  return (
    <div className={styles.s_update}>
      <div className="s_line">
        <div className="s_select_title">升级弹窗设置:</div>
        <div className="s_content">
          <div
            className="checkbox checkbox_clear"
            onClick={() => {
              handleSwitchEnabled(1);
            }}
          >
            {isEnabledUpdate ? <div className="checked" /> : <div className="no_checked" />}
            <span>开启升级弹窗</span>
          </div>
          <div className="desc desc_margin_top">建议您开启升级弹窗，以免错过大牌软件更新</div>
        </div>
      </div>

      <div className="s_line">
        <div className="s_select_title">不常用软件设置:</div>
        <div className="s_content">
          <div
            className="checkbox checkbox_clear"
            onClick={() => {
              handleSwitchEnabled(4);
            }}
          >
            {isEnabledRarelyUse ? <div className="checked" /> : <div className="no_checked" />}
            <span>开启不常用软件提醒</span>
          </div>
          <div className="desc desc_margin_top">建议您开启不常用软件提醒，及时管理我的软件。</div>
        </div>
      </div>

      <div className="s_line">
        <div className="s_select_title">卸载残留设置:</div>
        <div className="s_content">
          <div
            className="checkbox checkbox_clear"
            onClick={() => {
              handleSwitchEnabled(3);
            }}
          >
            {isEnabledResidual ? <div className="checked" /> : <div className="no_checked" />}
            <span>开启卸载残留提醒</span>
          </div>
          <div className="desc desc_margin_top">
            建议您开启卸载残留提醒，及时清理残留，释放空间。
          </div>
        </div>
      </div>

      {switchType && (
        <Dialog containerStyle={styles.update_modal} handleClose={hanldeCloseSwitchModal}>
          <div className={styles.update_content_modal}>{switchInfo[switchType].modalInfo}</div>
          <div>
            <Btn className={styles.updaye_btn_modal} handleClick={hanldeOkSwitchModal}>
              确定
            </Btn>
            <Btn primary className={styles.updaye_btn_modal} handleClick={hanldeCancelSwitchModal}>
              取消
            </Btn>
          </div>
        </Dialog>
      )}
    </div>
  );
});
